import Card from "./card";
import { Box } from "@mui/material";
import styles from "./style.module.css";
import { useSelector } from "react-redux";

function Liked() {
  const { likedProjects } = useSelector((state) => state.publicUser);

  const renderProjects = likedProjects.map((project, index) => {
    return <Card project={project} key={index} />;
  });

  return <Box className={styles.liked}>{renderProjects}</Box>;
}

export default Liked;
